import { useGetAccounts } from '@vindr/services/actions/account.action';
import { ACCOUNT_STATUS } from '@vindr/services/constants/common.constant';
import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '@vindr/ui/src/components/ui/Table';
import Filter from './Filter';
import useAccountSearchColumns from './useAccountSearchColumns';

const AccountSearch = ({ selectedAccounts, onSave, onCancel, initFilters }) => {
  console.log('🚀 ~ AccountSearch ~ selectedAccounts:', selectedAccounts)
  const { t } = useTranslation('Vindoc');
  const columns = useAccountSearchColumns({});
  const [params, setParams] = useState(initFilters);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  console.log('🚀 ~ AccountSearch ~ selectedRowKeys:', selectedRowKeys)
  const { data, isFetching, isLoading, refetch } = useGetAccounts({
    limit: 100,
    offset: 0,
    statuses: [ACCOUNT_STATUS.Active],
    ...params,
  });
  const accountList = data?.data;

  const [isRefetch, setIsRefetch] = useState(false);
  useEffect(() => {
    if (!isFetching) {
      // After fetching, set isRefetch to false;
      setIsRefetch(false);
    }
  }, [isFetching]);

  const forceSearch = (params) => {
    setParams(params);
    // Set refetch to true only when force search
    setIsRefetch(true);
    refetch?.();
  };

  useEffect(() => {
    setSelectedRowKeys(selectedAccounts.map((it) => it?.id));
  }, [selectedAccounts]);

  return (
    <div className="flex flex-col">
      <Filter
        initFilters={initFilters}
        onChange={(p) => {
          setParams(p);
        }}
        forceSearch={forceSearch}
      />
      <Table
        rowSelection={{
          selectedRowKeys,
          onChange: (keys, records) => {
            setSelectedRowKeys(keys);
          },
        }}
        columns={columns}
        loading={isLoading || isRefetch}
        dataSource={accountList || []}
        scroll={{ y: 450 }}
        rowKey="id"
        pagination={null}
        wrapperClassName="h-auto"
      />
      <div className="footer mt-3 flex flex-wrap items-end justify-end space-y-2">
        <Button onClick={onCancel}>{t('Cancel')}</Button>
        <Button
          type="primary"
          className="ml-2"
          onClick={() => onSave(accountList.filter((it) => selectedRowKeys.includes(it.id)))}
        >
          {t('Save')}
        </Button>
      </div>
    </div>
  );
};

export default AccountSearch;
